<template>
	<div>

		<!-- <input type="file"/> -->

		<div class="ns-body layui-body" style="left: 100px; top: 60px;">
			<!-- 内容 -->
			<div v-if="pageData" class="ns-body-content">
				<!-- 四级导航 -->



				<div class="ns-survey">
					<div class="ns-survey-left">
						<div class="ns-survey-item">


							<!-- 概况 -->
							<div class="layui-card ns-survey-info ns-card-common">
								<div class="layui-card-header" style="font-size: 14px;">
									<div>
										<span class="ns-card-title">概况</span>

									</div>
								</div>
								<div class="layui-card-body">
									<div class="ns-survey-detail-con">
										<div class="ns-survey-detail-aco">今日订单数
											<!-- <div class="ns-prompt-block" style="left: 100px;top: 20px;">
												<div class="ns-prompt">
													<el-tooltip style="margin-left: 10px;" class="item" effect="dark"
														content="只有经过支付的订单才会参与统计,支付后关闭的订单也参与统计。" placement="top-start">
														<i class="el-icon-info required ns-growth"></i>
													</el-tooltip>
												</div>
											</div> -->
										</div>
										
										
										<p class="ns-survey-detail-num ns-text-color">{{pageData.today.order_count}}</p>

										<div class="ns-survey-detail-split"></div>
										<div class="ns-survey-detail-total">
											<span>订单总数</span>
											<span>{{pageData.total.order_count}}</span>
										</div>
										<!-- <p class="ns-survey-detail-yesterday">昨日：0</p> -->
										<!-- 	<div class="title ns-prompt-block">
											<div class="ns-prompt">
												<el-tooltip class="item" effect="dark" content="订单数：0 "
													placement="right-start">
													<button
														class="layui-btn layui-btn-primary ns-text-color ns-border-color ns-survey-yesterday-btn">昨日</button>
												</el-tooltip>

											</div>
										</div> -->
									</div>
									<div class="ns-survey-detail-con">
										<p class="ns-survey-detail-aco">今日销售额(元)</p>
										<p class="ns-survey-detail-num ns-text-color">{{pageData.today.order_price}}</p>

										<div class="ns-survey-detail-split"></div>
										<div class="ns-survey-detail-total">
											<span>销售总额</span>
											<span>{{pageData.total.order_price}}</span>
										</div>
										<!-- <p class="ns-survey-detail-yesterday">昨日：0.00</p> -->
										<!-- 	<div class="title ns-prompt-block">
											<div class="ns-prompt">
												<el-tooltip class="item" effect="dark" content="销售额：0.00元"
													placement="right-start">
													<button
														class="layui-btn layui-btn-primary ns-text-color ns-border-color ns-survey-yesterday-btn">昨日</button>
												</el-tooltip>

											</div>
										</div> -->
									</div>
									<div class="ns-survey-detail-con">
										<p class="ns-survey-detail-aco">今日新增用户数</p>
										<p class="ns-survey-detail-num ns-text-color">{{pageData.today.add_user_count}}</p>

										<div class="ns-survey-detail-split"></div>
										<div class="ns-survey-detail-total">
											<span>用户总数</span>
											<span>{{pageData.total.user_count}}</span>
										</div>
										<!-- <div class="title ns-prompt-block">
											<div class="ns-prompt">
												<el-tooltip class="item" effect="dark" content="会员数：0 "
													placement="right-start">
													<button
														class="layui-btn layui-btn-primary ns-text-color ns-border-color ns-survey-yesterday-btn">昨日</button>
												</el-tooltip>

											</div>
										</div> -->
									</div>
									<div class="ns-survey-detail-con">
										<p class="ns-survey-detail-aco">今日活跃用户数</p>
										<p class="ns-survey-detail-num ns-text-color">{{pageData.today.activity_user_count}}</p>

										<div class="ns-survey-detail-split"></div>
										<div class="ns-survey-detail-total">
											<span>活跃总数</span>
											<span>{{pageData.total.user_activity_count}}</span>
										</div>
										<!-- <div class="title ns-prompt-block">
											<div class="ns-prompt">
												<el-tooltip class="item" effect="dark" content="浏览量：0 "
													placement="right-start">
													<button
														class="layui-btn layui-btn-primary ns-text-color ns-border-color ns-survey-yesterday-btn">昨日</button>
												</el-tooltip>
											</div>
										</div> -->
									</div>



								</div>
							</div>

						</div>

						<div v-if="role=='hq_admin'" class="statistics-wrap">
							<div class="item" style="flex:1">

								<div @click="go('/orderList?orderStatus=1')" class="flex-box" style="background: rgba(255, 69, 68, 0.1);">
									<h5 class="title">待发货订单</h5>
									<div class="num">{{pageData.total.order_express}}</div>
								</div>
								<div @click="go('/orderList?orderStatus=4')" class="flex-box" style="background: rgba(80, 130, 255, 0.1);">
									<h5 class="title">退款中订单</h5>
									<div class="num">{{pageData.total.order_refund}}</div>
								</div>
							</div>


							<div class="item" style="flex:1">
								
								<div @click="go('/orderList?invoice_status=1')" class="flex-box" style="background: rgba(38, 189, 216, 0.1)">
									<h5 class="title">发票申请</h5>
									<div class="num">{{pageData.total.order_invoice}}</div>
								</div>
								<!-- @click="go('/goodsList?understock=10')" -->
								<div  class="flex-box" style="background: rgba(255, 125, 68, 0.1);cursor: default;">
									<h5 class="title">库存预警</h5>
									<div class="num">{{pageData.total.goods_understock}}</div>
								</div>
								
							</div>

							<div class="item" style="flex:1">
								
								<!-- @click="go('/goodsList?goodsUpDownStatus=1')" -->
								<div  class="flex-box" style="background: rgba(60, 188, 66, 0.1);cursor: default;">
									<h5 class="title">出售中商品</h5>
									<div class="num">{{pageData.total.goods_release}}</div>
								</div>
								<!-- @click="go('/goodsList?goodsUpDownStatus=0')" -->
								<div  class="flex-box" style="background: rgba(255, 174, 68, 0.1);cursor:default;">
									<h5 class="title">仓库中商品</h5>
									<div class="num">{{pageData.total.goods_draft}}</div>
								</div>
								
							</div>


						</div>

						<div class="echarts-wrap">
							<!-- 近七天订单数echarts图表 start -->
							<div class="echarts-order">
								<h5>近七天订单数(个)</h5>
								<div id="orderEcharts" ref="orderEcharts" style="width: 100%; height: 400px; -webkit-tap-highlight-color: transparent; user-select: none; position: relative;">
								</div>
							</div>
							<!-- 近七天订单数echarts图表end -->

							<!-- 销售额echarts图表start -->
							<div class="echarts-money">
								<h5>销售额(元)</h5>
								<div id="moneyEcharts" ref="moneyEcharts" style="width: 100%; height: 400px; -webkit-tap-highlight-color: transparent; user-select: none; position: relative;">
								</div>
							</div>
							<!-- 销售额echarts图表end -->
						</div>

						<!-- 常用功能 -->
						<!-- <div class="layui-card ns-card-common">
							<div class="layui-card-header">
								<div>
									<span class="ns-card-title">常用功能</span>
								</div>
							</div>

							<div class="layui-card-body">
								<div class="common-functions">
								
									<div class="common-functions-item">
										<div class="common-functions-box">
											<div class="ns-item-pic">
												<img
													src="https://uniapp.v4.niuteam.cn/app/shop/view/public/img/menu_icon/issue_good.png">
											</div>
											<div class="ns-item-con">
												<div class="ns-item-content-title">发布商品</div>
												<p class="ns-item-content-desc">发布实物商品</p>
											</div>
										</div>
									</div>
									
									

								</div>
							</div>
						</div> -->


						<div class="addon-tool">

							<!-- 营销活动start -->
							<!-- <div class="layui-card ns-card-common">
								<div class="layui-card-header">
									<div>
										<span class="ns-card-title">营销活动</span>
									</div>
								</div>
								<div class="layui-card-body">
									<div class="ns-item-block-parent">
										
										<div class="addon-tool-item">
											<div class="ns-item-block-wrap">
												<div class="ns-item-pic">
													<img src="https://uniapp.v4.niuteam.cn/addon/bargain/icon.png">
												</div>
												<div class="ns-item-con">
													<div class="ns-item-content-title">砍价</div>
													<p class="ns-item-content-desc ns-line-hiding" title="邀请好友砍价后低价购买">
														邀请好友砍价后低价购买</p>
												</div>
											</div>
										</div>
										
										
									</div>
								</div>
							</div> -->
							<!-- 营销活动end -->


							<!-- 排行start -->
							<div style="background: #fff;border-radius: 10px;width: 100%;margin-top: 50px;padding: 20px;padding-bottom: 50px;">
								<!-- 筛选start -->
								<div style="display: flex;align-items: center;padding-left: 40px;margin-top: 10px;">

									<div style="display: flex;align-items: center;">
										<div style="font-size: 13px;margin-right: 10px;color: #888;">日期</div>
										<el-date-picker size="mini" style="" v-model="searchForm.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>

									</div>

									<div style="margin-left: 50px;">

										<el-button round style="margin-right: 10px;" @click="handleSearch" type="primary" icon="el-icon-search" size="small">搜索</el-button>
										<el-button round @click="handleReset" size="small">重置</el-button>

									</div>

								</div>
								<div style="border: 1px solid #EBEEF5;opacity: 0;margin-bottom: 30px;margin-top: 30px;"></div>
								
								<!-- 筛选end -->




								<div class="dis" style="align-items: flex-start;">
									<!-- 产品浏览量排行start -->
									<div class="layui-card-header" style="width: 30%;box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);border-radius: 12px;padding: 20px;">
										<div style="display: flex;align-items: center;">
											<span class=" ns-card-title" style="font-size: 15px;font-weight: bold;">产品浏览量排行</span>
											<img src="../../assets/p.png" style="width: 20px;height:20px;margin-left: 5px;" />
										</div>

										<div style="margin-top: 20px;">
											<!-- 项start -->
											<div v-for="(item,index) in view_goods" style="display: flex;align-items: flex-start;margin-bottom: 15px;">
												<img v-if="index==0" src="../../assets/d1.png" style="width: 30px;height: 30px;margin-right: 3px;margin-top: 10px;"/>
												<img v-else-if="index==1" src="../../assets/d2.png" style="width: 30px;height: 30px;margin-right: 3px;margin-top: 10px;"/>
												<img v-else-if="index==2" src="../../assets/d3.png" style="width: 30px;height: 30px;margin-right: 3px;margin-top: 10px;"/>
												<div v-else style="color:#9195a3;font-size: 16px;font-weight: bold;margin-right: 15px;margin-top: 12px;margin-left: 10px;">{{index+1}}</div>
												
												<img  @click="handlePreView(item.goods.image)" :src="item.goods.image" style="margin-right: 8px;width: 50px;height: 50px;border-radius: 10px;cursor: pointer;">
												<div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">名称：</div>
														
														<el-tooltip :content="item.goods.name" placement="right">
															<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;">{{item.goods.name}}</div>
														</el-tooltip>

													</div>
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">库存：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.goods.stock}}</div>
													</div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">销量：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.goods.sales}}</div>
													</div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">原价：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.goods.original_price}}</div>
													</div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">售价：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.goods.price}}</div>
													</div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;align-items: center;">
														<div style="flex-shrink: 0;">浏览量：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.count}}</div>
														<img v-if="index==0||index==1||index==2" src="../../assets/huo.png" style="width: 20px;height: 20px;margin-left: 5px;"/>
													</div>
													
													<div style="border: 1px solid #EBEEF5;opacity: 0.5;margin-top: 15px;"></div>
													
													
												</div>
											</div>
											<!-- 项end -->
											
											<div v-if="view_goods.length==0" style="text-align: center;font-size: 13px;color: #888;margin: 150px 0;">暂无信息~</div>
										</div>
								
									</div>
									<!-- 产品浏览量排行end -->
									
									
									
									<!-- 添加商品量排行start -->
									<div class="layui-card-header" style="width: 30%;box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);border-radius: 12px;padding: 20px;margin-left: 3%;margin-right: 3%;">
										<div style="display: flex;align-items: center;">
											<span class=" ns-card-title" style="font-size: 15px;font-weight: bold;">添加商品量排行</span>
											<img src="../../assets/p.png" style="width: 20px;height:20px;margin-left: 5px;" />
										</div>
									
										<div style="margin-top: 20px;">
											<!-- 项start -->
											<div v-for="(item,index) in cart_goods" style="display: flex;align-items: flex-start;margin-bottom: 15px;">
												<img v-if="index==0" src="../../assets/d1.png" style="width: 30px;height: 30px;margin-right: 3px;margin-top: 10px;"/>
												<img v-else-if="index==1" src="../../assets/d2.png" style="width: 30px;height: 30px;margin-right: 3px;margin-top: 10px;"/>
												<img v-else-if="index==2" src="../../assets/d3.png" style="width: 30px;height: 30px;margin-right: 3px;margin-top: 10px;"/>
												<div v-else style="color:#9195a3;font-size: 16px;font-weight: bold;margin-right: 15px;margin-top: 12px;margin-left: 10px;">{{index+1}}</div>
												
												<img @click="handlePreView(item.goods.image)" :src="item.goods.image" style="cursor: pointer;margin-right: 8px;width: 50px;height: 50px;border-radius: 10px;">
												<div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">名称：</div>
														
														<el-tooltip :content="item.goods.name" placement="right">
															<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;">{{item.goods.name}}</div>
														</el-tooltip>
									
													</div>
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">库存：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.goods.stock}}</div>
													</div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">销量：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.goods.sales}}</div>
													</div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">原价：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.goods.original_price}}</div>
													</div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">售价：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.goods.price}}</div>
													</div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;align-items: center;">
														<div style="flex-shrink: 0;">添加量：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.count}}</div>
														<img v-if="index==0||index==1||index==2" src="../../assets/huo.png" style="width: 20px;height: 20px;margin-left: 5px;"/>
													</div>
													
													<div style="border: 1px solid #EBEEF5;opacity: 0.5;margin-top: 15px;"></div>
													
													
												</div>
											</div>
											<!-- 项end -->
											
											<div v-if="view_goods.length==0" style="text-align: center;font-size: 13px;color: #888;margin: 150px 0;">暂无信息~</div>
										</div>
																	
									</div>
									<!-- 添加商品量排行end -->
									
									
									
									<!-- 购买商品量排行start -->
									<div class="layui-card-header" style="width: 30%;box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);border-radius: 12px;padding: 20px;">
										<div style="display: flex;align-items: center;">
											<span class=" ns-card-title" style="font-size: 15px;font-weight: bold;">购买商品量排行</span>
											<img src="../../assets/p.png" style="width: 20px;height:20px;margin-left: 5px;" />
										</div>
									
										<div style="margin-top: 20px;">
											<!-- 项start -->
											<div v-for="(item,index) in payment_goods" style="display: flex;align-items: flex-start;margin-bottom: 15px;">
												<img v-if="index==0" src="../../assets/d1.png" style="width: 30px;height: 30px;margin-right: 3px;margin-top: 10px;"/>
												<img v-else-if="index==1" src="../../assets/d2.png" style="width: 30px;height: 30px;margin-right: 3px;margin-top: 10px;"/>
												<img v-else-if="index==2" src="../../assets/d3.png" style="width: 30px;height: 30px;margin-right: 3px;margin-top: 10px;"/>
												<div v-else style="color:#9195a3;font-size: 16px;font-weight: bold;margin-right: 15px;margin-top: 12px;margin-left: 10px;">{{index+1}}</div>
												
												<img @click="handlePreView(item.goods.image)" :src="item.goods.image" style="cursor: pointer;margin-right: 8px;width: 50px;height: 50px;border-radius: 10px;">
												<div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">名称：</div>
														
														<el-tooltip :content="item.goods.name" placement="right">
															<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;">{{item.goods.name}}</div>
														</el-tooltip>
									
													</div>
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">库存：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.goods.stock}}</div>
													</div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">销量：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.goods.sales}}</div>
													</div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">原价：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.goods.original_price}}</div>
													</div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;">
														<div style="flex-shrink: 0;">售价：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.goods.price}}</div>
													</div>
													
													<div style="display: flex;font-size: 12px;color: #666;margin-bottom: 3px;align-items: center;">
														<div style="flex-shrink: 0;">购买量：</div>
														<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.count}}</div>
														<img v-if="index==0||index==1||index==2" src="../../assets/huo.png" style="width: 20px;height: 20px;margin-left: 5px;"/>
													</div>
													
													<div style="border: 1px solid #EBEEF5;opacity: 0.5;margin-top: 15px;"></div>
													
													
												</div>
											</div>
											<!-- 项end -->
											
											<div v-if="view_goods.length==0" style="text-align: center;font-size: 13px;color: #888;margin: 150px 0;">暂无信息~</div>
										</div>
																	
									</div>
									<!-- 购买商品量排行end -->

								</div>




							</div>

							<!-- 排行end -->


						</div>
					</div>
				</div>

			</div>


			<!-- 版权信息 -->
			<div class="ns-footer">
				<div class="ns-footer-img">
					<img :src="icon" style="width: 50px;height: 50px;">

				</div>
				<!-- <div style="margin-left: 10px;font-size: 13px;">MUE 沐懿</div> -->
				<!--<p>山西牛之云<a href="https://www.niushop.com">&nbsp;&nbsp;备案号晋ICP备16001360号-2</a></p>-->
				<!--<a class="gov-box" href=><img src="https://uniapp.v4.niuteam.cn/app/home/view/public/img/gov_record.png" alt="">公安备案121212121</a>-->
			</div>

		</div>

		<!-- 全屏透明的loading加载start -->
		<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->
		
		
		<!--浏览图片的弹窗start-->
		<el-dialog :close-on-click-modal="false" width="400px" footer-hide title="预览" :visible.sync="isShowPreImg">
			<img :src="preImgUrl" style="width: 100%">
		</el-dialog>
		<!--浏览图片的弹窗end-->


	</div>
</template>

<script>
	
	import {
		ajax
	} from '../../util/ajax.js';
	export default {
		name: '',
		components: {
			// start
			
		},
		data() {
			return {
				isShowPreImg: false, //是否显示浏览图片的弹窗
				preImgUrl: '', //浏览图片弹窗的图片地址
				
				view_goods:[],
				cart_goods:[],
				payment_goods:[],
				
				searchForm: {},
				tableData: '',
				role: '',
				loading: false,
				icon: require('@/assets/m1.png'),
				pageData: "",

			}
		},
		mounted() {
			// if (!window.name) {
			//   location.href += "?random=" + Date.now();
			//   window.name = "reloaded";
			// }



			console.log("缓存已清除88881")
			this.role = localStorage.getItem("role") ? localStorage.getItem("role").replace(/3alxi2fdksjfkljwijljsk128ldfln324kodnvjdsl32432jfiwefjls32432idaxpoife983iw2/g, '') : ''; //获取当前用户角色

			this.initData();

		},
		methods: {

			async initData() {
				this.loading = true;
				
				

				let res = await ajax('/summary/get', 'GET', {}, {}, false)
				
				console.log("index========执行成功")
			
				
				this.loading = false;
				this.pageData = res.data.data;

				let orderEchartsArrX = [];
				let orderEchartsArrY = [];

				let moneyEchartsArrX = [];
				let moneyEchartsArrY = [];

				for (let item of this.pageData.week) {
					orderEchartsArrY.push(item.order_count);
					orderEchartsArrX.push(item.create_date);

					moneyEchartsArrY.push(item.order_price);
					moneyEchartsArrX.push(item.create_date);
				}

				//图表start
				setTimeout(() => {
					let orderEcharts = this.$echarts.init(this.$refs.orderEcharts);
					let moneyEcharts = this.$echarts.init(this.$refs.moneyEcharts);
					orderEcharts.setOption({
						xAxis: {
							type: 'category',
							data: orderEchartsArrX
						},
						tooltip: {
							trigger: 'axis'
						},
						yAxis: {
							type: 'value'
						},
						series: [{
							data: orderEchartsArrY,
							type: 'line'
						}]
					});

					moneyEcharts.setOption({
						xAxis: {
							type: 'category',
							data: moneyEchartsArrX
						},
						tooltip: {
							trigger: 'axis'
						},
						yAxis: {
							type: 'value'
						},
						series: [{
							data: moneyEchartsArrY,
							type: 'line'
						}]
					});
				}, 1000)
				//图表end



				let searchForm = this.searchForm;
				if (searchForm.date === "" ||searchForm.date ===null) { //select未选中为空字符串
					searchForm.date = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.date && searchForm.date.length > 0) {
					//日期重新赋值为时间戳日期
					let arr = searchForm.date;
					if (arr[0].getTime) {
						searchForm.date = [arr[0].getTime(), arr[1].getTime()];
					} else {
						searchForm.date = arr;
					}
					
					

				}

				let rankingRes = await ajax('/ranking/get', 'GET', {...searchForm}, {}, false)
				this.tableData = rankingRes.data.data;
				this.view_goods = this.tableData.view_goods;
				this.cart_goods = this.tableData.cart_goods;
				this.payment_goods = this.tableData.payment_goods;
				
			},

			//浏览图片
			handlePreView(url) {
				this.preImgUrl = url
				this.isShowPreImg = true
			},

			go(url) {
				this.$router.push({
					path: url
				});
			},
			
			//搜索
			handleSearch() {
				//this.pageNumber = 1;
				this.initData()
			},
			
			//重置
			handleReset() {
			
				
				this.searchForm = {};
				//this.pageNumber = 1
				//this.pageSize = 10
				this.tableData = []; //表格数据修改为空
				this.view_goods=[];
				this.cart_goods=[];
				this.payment_goods=[];
				this.initData()
			},
			


		}
	}
</script>

<style scoped>
	.layui-layout-admin .layui-body .ns-body-content {
		min-width: 1200px;
		padding: 0 !important;
		margin: 0px !important;
	}

	.ns-card-common {
		margin-top: 0px !important;
	}

	/* @media screen and (max-width: 1270px) {
		.ns-survey-info .layui-card-body .ns-survey-detail-con {
			flex-basis: 33% !important;
		}
	} */


	.expire-hint {
		display: flex;
		align-items: center;
		padding: 15px 30px;
		height: 75px;
		line-height: 75px;
		background-color: #fff9f5;
		box-sizing: border-box;
	}

	.expire-hint .expire-logo {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 15px;
		width: 40px;
		height: 40px;
	}

	.expire-hint .expire-logo img {
		max-height: 100%;
		max-width: 100%;
	}

	.expire-hint .expire-center {
		line-height: 1;
	}

	.expire-hint .expire-center h3 {
		font-size: 15px;
		font-weight: 700;
	}

	.expire-hint .expire-center p {
		margin-top: 10px;
		color: #5d5c5c;
	}

	.expire-hint .expire-center p span:nth-of-type(2) {
		margin-left: 15px;
	}

	.expire-hint .expire-center h3 a {
		font-size: 12px;
		font-weight: normal;
		margin-left: 5px;
		cursor: pointer;
	}


	.ns-survey {
		display: flex;
		padding: 30px 40px;
		background: #f8f8f8;
		padding-top: 0px;
	}


	.ns-card-common .ns-card-title {
		font-weight: 500;
	}

	.ns-card-common .ns-card-sub {
		margin-left: 12px;
		color: #B7B8B7;
	}

	.ns-card-common .layui-card-header {
		border: 0;
		padding: 0;
		height: auto;
		line-height: 16px;
		padding: 20px 0;
	}

	.ns-card-common .layui-card-body {
		padding: 0;
	}

	.ns-item-block-parent .ns-item-block {
		background-color: transparent;
	}

	.ns-item-block-parent .ns-item-pic {
		overflow: hidden;
		border-radius: 5px;
	}

	.ns-item-block-parent {
		padding: 0;
		background: #f8f8f8;
	}


	.ns-survey-item .ns-survey-info {
		flex: 1;
		background: #f8f8f8;
	}

	.ns-survey-item {
		display: flex;
		justify-content: space-between;
	}

	.ns-survey-item .ns-survey-shop {
		display: flex;
		width: 350px;
		padding: 20px;
		box-sizing: border-box;
		border: 1px solid #f1f1f1;
	}

	.ns-survey-item .ns-survey-shop .ns-item-pic {
		display: flex;
		width: 65px;
		height: 65px;
		justify-content: center;
		align-items: center;
	}

	.ns-survey-item .ns-survey-shop .ns-item-pic img {
		max-width: 100%;
		max-height: 100%;
	}

	.ns-survey-item .ns-survey-shop .ns-surver-shop-detail {
		margin-left: 15px;
		flex: 1;
	}

	.ns-survey-item .ns-survey-shop .ns-survey-shop-name {
		font-size: 16px;
		font-weight: 600;
		color: rgba(38, 38, 38, 1);
		height: 25px !important;
		line-height: 25px !important;
		margin-bottom: 10px;
	}

	.ns-survey-item .ns-survey-shop .ns-survey-shop-name span {
		border: 1px solid #999;
		padding: 1px 2px;
		line-height: 1;
		color: #999;
		font-size: 12px;
		margin-left: 10px;
		border-radius: 2px;
		cursor: pointer;
	}

	.ns-survey-item .ns-survey-shop .ns-surver-shop-detail p {
		line-height: 30px;
		color: #595959;
	}

	.ns-survey-item .ns-survey-shop .ns-surver-shop-detail p:nth-of-type(2) {
		font-size: 12px;
		color: #B7B8B7;
	}


	.ns-survey-info {
		margin: 0;
	}

	.ns-survey-info .layui-card-body {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.ns-survey-info .layui-card-body .ns-survey-detail-con {
		display: inline-block;
		width: calc((100% - 90px) / 4);
		margin-right: 30px;
		margin-bottom: 30px;
		background-color: #FFF;
		padding: 0 20px;
		box-sizing: border-box;
		position: relative;
	}

	.ns-survey-info .layui-card-body .ns-survey-detail-con:last-child {
		margin-right: 0;
	}

	.ns-survey-info .layui-card-body .ns-survey-detail-aco {
		font-size: 16px;
		line-height: 18px;
		margin-top: 20px;
		font-weight: 400;
	}

	.ns-survey-info .layui-card-body .ns-survey-detail-num {
		margin: 10px 0;
		font-size: 36px;
		font-weight: 400;
		margin-top: 48px;
	}

	.ns-survey-detail-rate {
		font-size: 14px;
		line-height: 30px;
		display: flex;
		align-items: center;
		margin-top: 25px;
	}

	.ns-survey-detail-rate div i {
		margin-left: 5px;
	}

	.ns-survey-detail-rate div:nth-child(2) {
		margin-left: 25px;
	}

	.layui-icon-triangle-d {
		font-size: 12px;
		display: inline-block;
		transform: scale(0.8, 0.9);
		-webkit-transform: scale(0.8, 0.9);
		/*å…¼å®¹-webkit-å¼•æ“Žæµè§ˆå™¨*/
		-moz-transform: scale(0.8, 0.9);
		/*å…¼å®¹-moz-å¼•æ“Žæµè§ˆå™¨*/
		color: #5ED300;
	}

	.layui-icon-increase {
		transform: scale(0.8, 0.9) rotate(180deg);
		-ms-transform: rotate(180deg);
		/* IE 9 */
		-moz-transform: scale(0.8, 0.9) rotate(180deg);
		/* Firefox */
		-webkit-transform: scale(0.8, 0.9) rotate(180deg);
		/* Safari å’Œ Chrome */
		-o-transform: rotate(180deg);
		/* Opera */
	}

	.layui-icon-triangle-d.is-null {
		display: none;
	}

	.ns-survey-detail-split {
		width: 100%;
		height: 1px;
		background-color: #FFFFFF;
		margin-top: 25px;
	}

	.ns-survey-detail-total {
		display: flex;
		justify-content: space-between;
		margin: 18px 0 15px;
		font-size: 14px;
		line-height: 16px;
	}

	.ns-prompt-block {
		position: absolute;
		top: 18px;
		right: 20px;
		font-size: 12px;
		cursor: pointer;
	}

	.ns-prompt-block .ns-prompt {
		width: auto;
		height: auto;
		line-height: unset;
		text-align: right !important;
	}

	.ns-prompt-block .ns-prompt-box {
		top: 40px;
		left: -53px;
		width: 150px;
		text-align: center;
	}

	.ns-prompt-block .ns-prompt-box:before,
	.ns-prompt-block .ns-prompt-box:after {
		left: 62px;
		top: unset;
	}

	.ns-prompt-block .ns-prompt-box:before {
		border-bottom-color: #e4e4e4;
		border-right-color: transparent;
		top: -25px;
	}

	.ns-prompt-block .ns-prompt-box:after {
		border-bottom-color: #FFFFFF;
		border-right-color: transparent;
		top: -23px;
	}

	.ns-survey-yesterday-btn {
		font-size: 12px;
		width: 44px;
		height: 22px;
		padding: 0;
		line-height: 22px;
	}

	/* .ns-survey-info .layui-card-body .ns-survey-detail-yesterday {
		font-size: 14px;
		font-weight: 400;
		color: rgba(175, 175, 175, 1);
	} */

	/*  */
	.ns-survey-right .layui-card {
		border: 1px solid #f1f1f1;
		box-shadow: inherit;
	}

	.ns-survey-right .layui-card .layui-card-body {
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.ns-shop-state {
		margin: 30px 40px 0;
		padding: 10px;
		padding-right: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 35px;
		background-color: rgba(255, 129, 67, 0.1);
		color: #fff;
		border: 1px solid red;
	}

	.ns-shop-state p {
		color: #666;
	}

	.ns-shop-state p i {
		margin-right: 6px;
	}

	.ns-shop-state button {
		border: none;
		background-color: transparent;
		cursor: pointer;
	}


	.common-functions {
		width: 100%;
	}

	.common-functions-item {
		display: inline-block;
		width: 215px;
		background-color: #FFF;
		text-align: center;
		margin-right: 10px;
		margin-bottom: 15px;
		padding: 24px 20px;
		box-sizing: border-box;
	}

	.common-functions-item:last-child {
		margin-right: 0;
	}

	.common-functions-box .ns-item-pic {
		display: inline-block;
		width: 40px;
		height: 40px;
		text-align: center;
		line-height: 40px;
	}

	.common-functions-box .ns-item-pic img {
		max-width: 100%;
		max-height: 100%;
	}

	.common-functions-box .ns-item-content-title {
		font-size: 14px;
		line-height: 14px;
		margin-top: 17px;
	}

	.common-functions-box .ns-item-content-desc {
		font-size: 12px;
		color: #666666;
		line-height: 12px;
		margin-top: 9px;
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.addon-tool {
		width: 100%;
		display: flex;
	}

	.addon-tool .ns-card-common {
		width: 100%;
		background: #f8f8f8;
	}

	.addon-tool .addon-tool-item {
		width: 270px;
		padding: 5px 0 5px 50px;
		background-color: #FFF;
		box-sizing: border-box;
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.ns-survey-left {
		flex: 1;
	}

	.ns-survey-left>.ns-card-common {
		margin-top: 40px;
		background: #f8f8f8;
	}

	/* å›¾è¡¨ */
	.echarts-wrap {
		display: flex;
		justify-content: space-between;
	}

	.echarts-wrap>div {
		width: 49%;
		background-color: #FFF;
	}

	.echarts-wrap>div h5 {
		font-size: 16px;
		padding-left: 20px;
		padding-top: 20px;
	}

	.statistics-wrap {
		display: flex;
	}

	.statistics-wrap .item {
		display: inline-block;
		width: calc((100% - 90px) / 4);
		margin-right: 30px;
		margin-bottom: 30px;
		display: flex;
	}

	.statistics-wrap .item:last-child {
		margin-right: 0;
	}

	.statistics-wrap .item .flex-box {
		flex: 1;
		background: #f5f5f5;
		height: 120px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		cursor: pointer;
	}

	.statistics-wrap .item .flex-box:first-child {
		margin-right: 30px;
	}

	.statistics-wrap .flex-box .title {
		font-size: 14px;
	}

	.statistics-wrap .flex-box .num {
		font-size: 28px;
		font-weight: 400;
		color: #FF8143;
		margin-top: 10px;
	}

	.el-main {
		padding: 0;
	}

	.ns-survey-info .layui-card-body .ns-survey-detail-aco {
		font-size: 16px;
		line-height: 18px;
		margin-top: 20px;
		font-weight: 400;
	}

	.ns-prompt-block {
		position: absolute;
		top: 18px;
		right: 20px;
		font-size: 12px;
		cursor: pointer;
	}

	.ns-prompt-block .ns-prompt {
		width: auto;
		height: auto;
		line-height: unset;
	}

	.ns-prompt-block .ns-prompt-box {
		top: 40px;
		left: -53px;
		width: 150px;
		text-align: center;
	}

	.ns-prompt-block .ns-prompt-box:before,
	.ns-prompt-block .ns-prompt-box:after {
		left: 62px;
		top: unset;
	}

	.ns-prompt-block .ns-prompt-box:before {
		border-bottom-color: #e4e4e4;
		border-right-color: transparent;
		top: -25px;
	}

	.ns-prompt-block .ns-prompt-box:after {
		border-bottom-color: #FFFFFF;
		border-right-color: transparent;
		top: -23px;
	}

	.ns-survey-yesterday-btn {
		font-size: 12px;
		width: 44px;
		height: 22px;
		padding: 0;
		line-height: 22px;
	}

	.ns-border-color {
		border-color: #FF6A00 !important;
	}

	.ns-text-color {
		color: #FF6A00 !important;
	}

	.layui-btn-primary {
		border: 1px solid #C9C9C9;
		background-color: #fff;
		color: #555;
	}


	.layui-btn {
		display: inline-block;
		white-space: nowrap;
		text-align: center;
		border-radius: 2px;
		cursor: pointer;
	}

	.ns-card-common {

		margin-bottom: 0;
		box-shadow: initial;
	}

	.layui-card-header {
		position: relative;
		color: #333;
		border-radius: 2px 2px 0 0;
		font-size: 14px;
	}

	.ns-item-block-parent {

		width: 100%;
		display: flex;
		flex-wrap: wrap;

		box-sizing: border-box;
		border-radius: 5px;
	}

	.ns-item-content-title {
		color: #333;
	}

	.ns-item-block-parent .ns-item-block-wrap {
		padding: 15px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
	}

	.ns-item-block-parent .ns-item-pic {
		flex-shrink: 0;
		width: 40px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		margin-right: 10px;
	}

	.ns-item-block-parent .ns-item-con {
		overflow: hidden;
		height: 40px;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}

	.ns-item-block-parent .ns-item-con .ns-item-content-title {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 20px;
		font-size: 14px;
		color: #666;
	}

	.ns-item-block-parent .ns-item-con .ns-item-content-desc {
		line-height: 20px;
		font-size: 12px;
		color: #999;
	}

	.ns-line-hiding {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		white-space: normal;
		word-break: break-all;
	}

	.ns-item-block-parent .ns-item-pic img {
		max-width: 100%;
		max-height: 100%;
	}
</style>
